import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Container, Row, Col, Form } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';

function Master_Entity_List() {
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [scrMode, setScrMode] = useState("Q");  // "Q A E "
    const [entityData, setEntityData] = useState([]);

    const [showAddNewBtn, setShowAddNewBtn] = useState(true);
    const [showAddEditForm, setAddEditFormShow] = useState(false);

    const [enType, setEnType] = useState("A");
    const [ddEnTypeOptions, setDdEnTypeOptions] = useState([]);

    const [enId, setEnId] = useState(0);
    const [enName, setEnName] = useState("");
    const [enPan, setEnPan] = useState("");

    const [enActive, setEnActive] = useState(0);
    const [ddEnActiveOptions, setDdEnActiveOptions] = useState([]);

    const [enCountry, setEnCountry] = useState(0);
    const [ddEnCountryOptions, setDdEnCountryOptions] = useState([]);

    const [enState, setEnState] = useState(0);
    const [ddEnStateOptions, setDdEnStateOptions] = useState([]);

    const [enCity, setEnCity] = useState(0);
    const [ddEnCityOptions, setDdEnCityOptions] = useState([]);

    const [enAddress1, setEnAddress1] = useState("");
    const [enAddress2, setEnAddress2] = useState("");
    const [enAddress3, setEnAddress3] = useState("");
    const [enPhoneno, setEnPhoneno] = useState("");
    const [enMobileno, setEnMobileno] = useState("");
    const [enEmail, setEnEmail] = useState("");
    const [enCntlBran, setEnCntlBran] = useState(0);
    const [ddEnCntlBranOptions, setDdEnCntlBranOptions] = useState([]);
    const [enBankCharges, setEnBankCharges] = useState(0);

    const [filterType, setFilterType] = useState("A");
    const [ddFilterTypeOptions, setDdFilterTypeOptions] = useState([]);

    const [enEnquiryEmail, setEnEnquiryEmail] = useState("");
    const [enSwiftEmail, setEnSwiftEmail] = useState("");
    const [enScope, setEnScope] = useState("L");
    const [enEnquiryModule, setEnEnquiryModule] = useState("0");

    const [userRight, setUserRight] = useState([]);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            setDdEnActiveOptions([{ name: "Active", value: "1" }, { name: "Inactive", value: "0" }]);
            setDdEnTypeOptions([{ name: "Branch", value: "B" }, { name: "Agent", value: "A" }]);
            setDdFilterTypeOptions([{ name: "Branch", value: "B" }, { name: "Agent", value: "A" }]);
            Common.callApi(Common.apiRight, [sid, 'all', 'ENTITY'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            Common.callApi(Common.apiCountry, [sid, 'ddlistjson'], function (result) {
                setDdEnCountryOptions(JSON.parse(result));
            });
            Common.callApi(Common.apiState, [sid, 'ddlistjson', 0], function (result) {
                setDdEnStateOptions(JSON.parse(result));
                setEnState(0);
            });
            Common.callApi(Common.apiCity, [sid, 'ddlistjson', 0], function (result) {
                setDdEnCityOptions(JSON.parse(result));
                setEnCity(0);
            });
            Common.callApi(Common.apiEntity, [sid, 'ddlistjson', 'B'], function (result) {
                setDdEnCntlBranOptions(JSON.parse(result));
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    function getList(typ) {
        Common.callApi(Common.apiEntity, [sid, 'listjson', typ], function (result) {
            setEntityData(JSON.parse(result));
        });
    }

    function showList() {
        getList(filterType);
    }

    function refreshFormState(id) {
        setEnCountry(id);
        Common.callApi(Common.apiState, [sid, 'ddlistjson', id], function (result) {
            setDdEnStateOptions(JSON.parse(result));
            setEnState(0);
        });
        Common.callApi(Common.apiCity, [sid, 'ddlistjson', 0], function (result) {
            setDdEnCityOptions(JSON.parse(result));
            setEnCity(0);
        });
    }

    function refreshFormCity(id) {
        setEnState(id);
        Common.callApi(Common.apiCity, [sid, 'ddlistjson', id], function (result) {
            setDdEnCityOptions(JSON.parse(result));
            setEnCity(0);
        });
    }

    function addNew() {
        setScrMode("A");
        setEnType("A");
        setEnId(0);
        setEnName("");
        setEnPan("");
        setEnActive(1);
        setEnCountry(0);
        setEnState(0);
        setEnCity(0);
        setEnAddress1("");
        setEnAddress2("");
        setEnAddress3("");
        setEnPhoneno("");
        setEnMobileno("");
        setEnEmail("");
        setEnEnquiryEmail("");
        setEnSwiftEmail("");
        setEnScope("L");
        setEnCntlBran(0);
        setEnBankCharges(0);
        setEnEnquiryModule("0");
        setAddEditFormShow(true);
        setShowAddNewBtn(false);
    }

    function saveData() {
        if (enName === "" || enAddress1 === "" || (enType === "A" && enPan === "") || enCountry === 0 || enState === 0 || enCity === 0 || (enCntlBran === "0" && enType === "A")
            || enBankCharges === ""
        ) {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {
            var object1 = {
                enType: enType,
                enId: enId,
                enName: enName,
                enPan: enPan,
                enActive: enActive,
                enCountry: enCountry,
                enState: enState,
                enCity: enCity,
                enAddress1: enAddress1,
                enAddress2: enAddress2,
                enAddress3: enAddress3,
                enPhoneno: enPhoneno,
                enMobileno: enMobileno,
                enEmail: enEmail,
                enCntlBran: enCntlBran,
                enEnquiryEmail: enEnquiryEmail,
                enSwiftEmail: enSwiftEmail,
                enScope: enScope,
                enBankCharges: enBankCharges,
                enEnquiryModule: enEnquiryModule
            };
            Common.callApi(Common.apiEntity, [sid, 'save', enId, JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    setScrMode("Q");
                    setAddEditFormShow(false);
                    setShowAddNewBtn(true);
                    getList(filterType);
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        }
    }

    function cancelData() {
        setAddEditFormShow(false);
        setShowAddNewBtn(true);
    }

    function fillEditForm(key) {
        let keyArr = key.split('^')
        Common.callApi(Common.apiEntity, [sid, 'detail', keyArr[0], keyArr[1]], function (result) {
            let resp = JSON.parse(result);
            setEnType(resp.enType);
            setEnId(resp.enId);
            setEnName(resp.enName);
            setEnPan(resp.enPan);
            setEnActive(resp.enActive);
            setEnAddress1(resp.enAddress1);
            setEnAddress2(resp.enAddress2);
            setEnAddress3(resp.enAddress3);
            setEnPhoneno(resp.enPhoneno);
            setEnMobileno(resp.enMobileno);
            setEnEmail(resp.enEmail);
            setEnCntlBran(resp.enCntlBran);
            setEnEnquiryEmail(resp.enEnquiryEmail);
            setEnSwiftEmail(resp.enSwiftEmail);
            setEnScope(resp.enScope);
            setAddEditFormShow(true);
            setShowAddNewBtn(false);
            setEnCountry(resp.enCountry);
            setEnBankCharges(resp.enBankCharges);
            setEnEnquiryModule(resp.enEnquiryModule);
            Common.callApi(Common.apiState, [sid, 'ddlistjson', resp.enCountry], function (result) {
                setDdEnStateOptions(JSON.parse(result));
                setEnState(resp.enState);
            });
            Common.callApi(Common.apiCity, [sid, 'ddlistjson', resp.enState], function (result) {
                setDdEnCityOptions(JSON.parse(result));
                setEnCity(resp.enCity);
            });
            setScrMode("E");
        });
    }

    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>Entity Master </h1>
                    </Col>
                </Row>
                {showAddNewBtn ?
                    <Row>
                        <Col>
                            {userRight.add === "1" ?
                                <Button variant="outline-primary" size="sm" onClick={addNew}>Add New</Button>
                                : null}
                        </Col>
                    </Row>
                    : null
                }
                <Row><Col>&nbsp;</Col></Row>
                {showAddEditForm ?
                    <Row>
                        <Col>

                            <Form>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Type</Form.Label>
                                            <Form.Select
                                                value={enType}
                                                onChange={(e) => setEnType(e.target.value)}
                                                disabled={(scrMode === "E" || scrMode === "Q")}

                                            >
                                                {ddEnTypeOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Serial Number</Form.Label>
                                            <Form.Control type="text" value={enId} disabled />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Name<span className="mandatory">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Name" maxLength={100}
                                                value={enName} onChange={(e) => setEnName(e.target.value)} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>PAN{enType === "A" ? <span className="mandatory">*</span> : null}</Form.Label>
                                            <Form.Control type="text" placeholder="PAN" maxLength={10}
                                                value={enPan} onChange={(e) => setEnPan(e.target.value)} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Address Line 1<span className="mandatory">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Line 1" maxLength={100}
                                                value={enAddress1} onChange={(e) => setEnAddress1(e.target.value)} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Address Line 2</Form.Label>
                                            <Form.Control type="text" placeholder="Line 2" maxLength={100}
                                                value={enAddress2} onChange={(e) => setEnAddress2(e.target.value)} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Address Line 3</Form.Label>
                                            <Form.Control type="text" placeholder="Line 3" maxLength={100}
                                                value={enAddress3} onChange={(e) => setEnAddress3(e.target.value)} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Country<span className="mandatory">*</span></Form.Label>
                                            <Form.Select
                                                value={enCountry}
                                                onChange={(e) => refreshFormState(e.target.value)}
                                            >
                                                {ddEnCountryOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>

                                    <Col>
                                        <Form.Group>
                                            <Form.Label>State<span className="mandatory">*</span></Form.Label>
                                            <Form.Select
                                                value={enState}
                                                onChange={(e) => refreshFormCity(e.target.value)}
                                            >
                                                {ddEnStateOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>City<span className="mandatory">*</span></Form.Label>
                                            <Form.Select
                                                value={enCity}
                                                onChange={(e) => setEnCity(e.target.value)}
                                            >
                                                {ddEnCityOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Phone No </Form.Label>
                                            <Form.Control type="text" placeholder="Phone" maxLength={50}
                                                value={enPhoneno} onChange={(e) => setEnPhoneno(e.target.value)} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Mobile No </Form.Label>
                                            <Form.Control type="text" placeholder="Phone" maxLength={50}
                                                value={enMobileno} onChange={(e) => setEnMobileno(e.target.value)} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Email </Form.Label>
                                            <Form.Control type="email" placeholder="Email" maxLength={100} autoComplete="off"
                                                value={enEmail}
                                                onChange={(e) => setEnEmail(e.target.value)}
                                                onBlur={(e) => Common.validtateEmail(e.target.value, setEnEmail)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    {
                                        enType === "A" ? <>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Bank Charges </Form.Label>
                                                    <Form.Control type="text" placeholder="Bank Charges" maxLength={10} autoComplete="off"
                                                        value={enBankCharges}
                                                        onChange={(e) => setEnBankCharges(e.target.value)}
                                                        onBlur={(e) => Common.validateNumValue(e.target.value, setEnBankCharges)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </> : null
                                    }
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Status</Form.Label>
                                            <Form.Select
                                                value={enActive}
                                                onChange={(e) => setEnActive(e.target.value)}
                                            >
                                                {ddEnActiveOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    {
                                        enType === "A" ?
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Controlling Branch</Form.Label>
                                                    <Form.Select
                                                        value={enCntlBran}
                                                        onChange={(e) => setEnCntlBran(e.target.value)}
                                                    >
                                                        {ddEnCntlBranOptions.map((res) =>
                                                            <option key={res.value} value={res.value}>{res.name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            : <>
                                                <Col>&nbsp;</Col>
                                                <Col>&nbsp;</Col>
                                            </>
                                    }


                                </Row>
                                {
                                    enType === "A" ?
                                        <>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Enquiry Email </Form.Label>
                                                        <Form.Control type="Enquiry Email" placeholder="Enquiry Email" maxLength={100} autoComplete="off"
                                                            value={enEnquiryEmail}
                                                            onChange={(e) => setEnEnquiryEmail(e.target.value)}
                                                            onBlur={(e) => Common.validtateEmail(e.target.value, setEnEnquiryEmail)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Swift Email </Form.Label>
                                                        <Form.Control type="Swift Email" placeholder="Swift Email" maxLength={100} autoComplete="off"
                                                            value={enSwiftEmail}
                                                            onChange={(e) => setEnSwiftEmail(e.target.value)}
                                                            onBlur={(e) => Common.validtateEmail(e.target.value, setEnSwiftEmail)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group >
                                                        <Form.Label>Scope<span className="mandatory">*</span></Form.Label>
                                                        <Form.Select
                                                            value={enScope}
                                                            onChange={(e) => setEnScope(e.target.value)}
                                                        >
                                                            <option value="L">Local</option>
                                                            <option value="G">Global</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group >
                                                        <Form.Label>Enquiry Mandatory<span className="mandatory">*</span></Form.Label>
                                                        <Form.Select
                                                            value={enEnquiryModule}
                                                            onChange={(e) => setEnEnquiryModule(e.target.value)}
                                                        >
                                                            <option value="0">No</option>
                                                            <option value="1">Yes</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>


                                            </Row>
                                        </> : null
                                }

                                <Row><Col>&nbsp;</Col></Row>
                                <Row>
                                    <Col>
                                        <Button variant="outline-success" size="sm" onClick={() => saveData()}>Save</Button>&nbsp;
                                        <Button variant="outline-danger" size="sm" onClick={() => cancelData()}>Cancel</Button>
                                    </Col>
                                </Row>
                                <Row><Col>&nbsp;</Col></Row>
                            </Form>

                        </Col>
                    </Row>
                    :
                    <>
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Select
                                        value={filterType}
                                        onChange={(e) => setFilterType(e.target.value)}>
                                        {ddFilterTypeOptions.map((res) =>
                                            <option key={res.value} value={res.value}>{res.name}</option>
                                        )}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col><Button variant="outline-primary" size="sm" onClick={() => showList()}>List</Button></Col>
                            <Col>&nbsp;</Col>
                            <Col>&nbsp;</Col>
                        </Row>
                        <Row><Col>&nbsp;</Col></Row>
                        <Row>
                            <Col>
                                <Table responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            {userRight.edit === "1" ? <th></th> : null}
                                            <th>Type</th>
                                            <th className="textRight">Sr No</th>
                                            <th>Entity</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {entityData.map((res) =>
                                            <tr key={res.entity_key}>
                                                {userRight.edit === "1" ?
                                                    <td className="textCenter" >
                                                        <span className="handCursor" onClick={() => fillEditForm(res.entity_key)} >
                                                            <div className="colorThemeBlue"><FontAwesomeIcon icon={faEdit} /></div>
                                                        </span>
                                                    </td>
                                                    : null
                                                }
                                                <td >{res.entity_type_name}</td>
                                                <td className="textRight">{res.entity_id}</td>
                                                <td>{res.entity_name}</td>
                                                <td>{res.entity_active}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </>
                }


            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
        </>
    );
}
export default Master_Entity_List; 